import { Box, Button, Paper } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import React from 'react'
import styled from 'styled-components'

import {
  BLOG_STATUS,
  BLOG_STATUS_TRANSITION_TYPE
} from '../../constants/enums/blog.enum.constant'

const StyledPaperContainer = styled(Paper)`
  height: 100%;
  margin: 10px 0px;
  padding: 20px;
`

const StyledButtonContainer = styled.div`
  margin: 0px 5px 0px 5px;
`

const StyledButton = (props: any) => (
  <StyledButtonContainer>
    <Button {...props} />
  </StyledButtonContainer>
)

const BlogFormHandlerBar = ({
  saveHandler,
  createHandler,
  statusChangeHandler,
  disableForm,
  newForm,
  blogStatus
}: {
  saveHandler: (...args: any) => any
  createHandler: (...args: any) => any
  statusChangeHandler: (...args: any) => any
  disableForm: boolean
  newForm: boolean
  blogStatus: number
}) => {
  return (
    <StyledPaperContainer>
      <Box display="flex" justifyContent="flex-end">
        {newForm ? (
          <StyledButton
            variant="contained"
            color="primary"
            onClick={createHandler}
          >
            Create
          </StyledButton>
        ) : (
          <>
            <StyledButton
              variant="outlined"
              color="default"
              onClick={saveHandler}
              disabled={disableForm}
            >
              Save
            </StyledButton>
            {!disableForm &&
              (blogStatus === BLOG_STATUS.draft ? (
                <StyledButton
                  variant="contained"
                  color="primary"
                  onClick={statusChangeHandler(
                    BLOG_STATUS_TRANSITION_TYPE.publish
                  )}
                >
                  Publish
                </StyledButton>
              ) : (
                <StyledButton
                  variant="outlined"
                  color="primary"
                  onClick={statusChangeHandler(
                    BLOG_STATUS_TRANSITION_TYPE.unpublish
                  )}
                >
                  Unpublish
                </StyledButton>
              ))}
            {!disableForm ? (
              <StyledButton
                variant="contained"
                color="secondary"
                onClick={statusChangeHandler(
                  BLOG_STATUS_TRANSITION_TYPE.archive
                )}
              >
                <DeleteIcon />
                Archive
              </StyledButton>
            ) : (
              <StyledButton
                variant="contained"
                color="primary"
                onClick={statusChangeHandler(
                  BLOG_STATUS_TRANSITION_TYPE.reopen
                )}
              >
                Reopen
              </StyledButton>
            )}
          </>
        )}
      </Box>
    </StyledPaperContainer>
  )
}

export default BlogFormHandlerBar
